"use client";
import { useState, useEffect } from "react";

interface LoadingProgressBarProps {
    initial?: number;
    height?: string;
    color?: string;
    bgcolor?: string;
    autoStart?: boolean;
    interval?: number;
    className?: string;
}

const LoadingProgressBar: React.FC<LoadingProgressBarProps> = ({ initial = 0, height = 'h-2', color = 'bg-[#FFF3]', bgcolor = 'bg-gray-700', autoStart = true, interval = 20, className = '' }) => {
    const [progress, setProgress] = useState(Math.max(0, Math.min(100, initial)));

    useEffect(() => {
        if (!autoStart || progress >= 100) return;

        const currentDelay = progress >= 80 ? interval * (progress - 75) : interval;

        const timer = setTimeout(() => {
            setProgress((prev) => Math.min(prev + 1, 100));
        }, currentDelay);

        return () => clearTimeout(timer);
    }, [progress, interval, autoStart]);


    return (
        <div className={`w-full ${bgcolor} rounded-full ${height} ${className}`}>
            <div
                className={`${color} ${height} rounded-full transition-all duration-500 ease-out`}
                style={{ width: `${progress}%` }}
                role="progressbar"
                aria-valuenow={progress}
                aria-valuemin={0}
                aria-valuemax={100}
            />
        </div>
    );
};

export default LoadingProgressBar;
